export default "__VITE_ASSET__43fcef84__"